import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Community } from '@app/_models/community';
import { DeviceConfig } from '@app/_models/devices';
import { CommunityAccess, AuthResponse } from '@app/_models/responses';
import { Role } from '@app/_models/role';
import { AuthenticationService } from '@app/_services';
import { AccessManagementService } from '@app/_services/access-management.service';
import { DeviceService } from '@app/_services/device.service';
import { PropertyService } from '@app/_services/property.service';
import { faBuilding, faBell, faUsers, faUser, faSearch, faPhoneAlt, faUnlockAlt, faEnvelope, faCog, faCogs,
    faUserGear, faClipboardUser, faClipboardCheck, faKey } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

  loading = false;

    faBuilding = faBuilding;
    faBell = faBell;
    faUsers = faUsers;
    faUser = faUser;
    faSearch = faSearch;
    faPhoneAlt = faPhoneAlt;
    faUnlockAlt = faUnlockAlt;
    faEnvelope = faEnvelope;
    faCog = faCog;
    faCogs = faCogs;
    faUserGear = faUserGear;
    faClipboardUser = faClipboardUser;
    faKey = faKey;
    //users: User[];
    communities!: Community[] | undefined;
    accesslist!: CommunityAccess[];
    tempconfig!: DeviceConfig[];
    devconfig!: DeviceConfig[];

    currentUser?: AuthResponse | null;

    constructor(private communityService: PropertyService, private router: Router,
        private authenticationService: AuthenticationService,
        private deviceService: DeviceService,
        private accessManagementService: AccessManagementService) {
            //this.authenticationService.currentUser.subscribe(x => this.currentUser = x );
            this.currentUser = this.authenticationService.currentUserValue || null;
        }

    ngOnInit() {
        this.loading = true;
        this.requestPermission();
        let accmng = this.authenticationService.currentUserValue?.username || '';
        this.accessManagementService.getAllAccess(accmng)

            .subscribe(
            data => {
                localStorage.setItem('accesslist', JSON.stringify(data));
            },
            error => {

            }
        );


        let user = this.authenticationService!.currentUserValue!.username || '';
        this.accessManagementService.getPropertySubscriptions(user)
        .subscribe(
          data => {
              localStorage.setItem('user_subscriptions', JSON.stringify(data));
          },
          error => {

          }
        );

        let userac = this.authenticationService!.currentUserValue!.username || '';
        this.accessManagementService.getDeviceSubscriptions(userac)
        .subscribe(
            data => {
                localStorage.setItem('devices_available', JSON.stringify(data));
            },
            error => {

            }
        );

        this.deviceService.getDeviceConfiguration().subscribe(
            data => {
                this.devconfig = data;

                localStorage.setItem('dev_config', JSON.stringify(this.devconfig));
            },
            error => {
                console.log('Failed to fetch configuration');
            }
        );

    }

    searchCommunities() {
        this.router.navigate(['/property'])
    }

    isAdmin() {
        //return this.currentUser;
        if (this.currentUser) {
            if (this.currentUser.access_token != undefined && this.currentUser.role != undefined) {
                return this.currentUser.role.includes(Role.ROLE_ADMIN);
            }
            else {
              return false;
            }

        }
        return false;
    }

    isSuper() {
        if (this.currentUser) {
            if (this.currentUser.access_token != undefined && this.currentUser.role != undefined) {
                return this.currentUser.role.includes(Role.ROLE_SUPER);
            } else {
              return false;
            }

        }
        return false;

    }

    requestPermission() {
        // this.afMessaging.requestPermission
        //   .pipe(mergeMapTo(this.afMessaging.tokenChanges))
        //   .subscribe(
        //     (token) => { console.log('Permission granted! Save to the server!', token); },
        //     (error) => { console.error(error); },
        //   );
    }




    checkSubscriptions() {
        let subs = localStorage.getItem("user_subscriptions") || '{}';
        this.accesslist = JSON.parse(subs);

        if (this.accesslist.length == 0){

            alert('You do not have any gate/property subscriptions. Use Find Community and request Access.');
        }
        if (this.accesslist.length == 1) {
            this.router.navigate(['/operate-device/'+this.accesslist[0].id]);
        }
        if (this.accesslist.length > 1) {
            this.router.navigate(['/available-properties/operate']);
        }
        //this.router.navigate(['/operate-device']);
    }

    openGuestAccess() {
        this.router.navigate(['/guest-access']);
    }

}
